import React from 'react';
import { Loader } from '@fortum/elemental-ui';
import { Container } from './styles';

export const FullPageLoader: React.FC = () => (
  <Container>
    <Loader />
  </Container>
);
